var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 400 400",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.9,308.9c-2.7,0-6.1-0.7-10.2-2.9c-0.3-0.1-26.3-13.3-43.3-6.2c-13.3,5.6-27.4,8.4-41.9,8.4 C139.6,308.2,91,259.5,91,199.7c0-59.9,48.7-108.5,108.5-108.5S308,139.8,308,199.7c0,20.3-5.7,40.1-11.3,49.2 c-1.1,1.9-1.4,11.1,2,21.1l6.3,18.4c3.6,10.5,0,15.6-2.4,17.7C301.2,307.4,298.7,308.9,294.9,308.9z M253.1,285.8 c18.3,0,36.2,9,37.1,9.5c2.2,1.1,3.6,1.4,4.3,1.5c0-0.7-0.1-2.1-0.9-4.5l-6.3-18.4c-3.6-10.5-5-24.6-0.9-31.3 c3.7-6,9.5-22.9,9.5-42.9c0-53.2-43.3-96.5-96.5-96.5S103,146.5,103,199.7c0,53.2,43.3,96.5,96.5,96.5c12.9,0,25.5-2.5,37.3-7.5 C242,286.6,247.5,285.8,253.1,285.8z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "189.7,250.4 148.1,214.4 156,205.3 188.1,233.1 244.9,160.6 254.3,168.1  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationSuccess);
export default __webpack_public_path__ + "static/media/notification_success.e5ac675b.svg";
export { ForwardRef as ReactComponent };